// import { useDispatch } from "react-redux";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Logout, Sidebar_Handle_Open } from "../Actions/LoginAction";
import { useState } from "react";
// import { LOGOUT_USER } from "../Action/UserAction";

export default function SidePanel({ page }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const sidebar = false;
  //   const { sidebar } = useSelector((s) => s.Sidebar_Reducer);
  const MobileScreen = window.innerWidth;

  const handleLogout = (e) => {
    e.preventDefault();
    dispatch(Logout());
  };
  const handleSidebar = (e) => {
    e.preventDefault();
    if (MobileScreen <= 780) {
      dispatch(Sidebar_Handle_Open(true));
    }
  };

  return (
    <div className={sidebar ? "sidebar active" : "sidebar"}>
      <div className="logo-details">
        <img
          src={
            MobileScreen <= 780
              ? sidebar
                ? "/assets/img/white-logo.png"
                : "/assets/img/white-logo.png"
              : sidebar
              ? "/assets/img/SE-logo.ong"
              : "/assets/img/white-logo.png"
          }
          alt="logo"
        />
      </div>
      <ul className="nav-links">
        <li onClick={handleSidebar}>
          <Link to="/" className={page === "File" ? "active" : ""}>
            <i className="bx bx-grid-alt"></i>
            <span className="links_name">File</span>
          </Link>
        </li>
        {/* <li onClick={handleSidebar}>
          <Link to="/reports" className={page === "Reports" ? "active" : ""}>
            <i className="bx bx-list-ul"></i>
            <span className="links_name">Reports</span>
          </Link>
        </li> */}

        <li className="log_out" onClick={handleLogout}>
          <Link to="#">
            <i className="bx bx-log-out"></i>
            <span className="links_name">Log out</span>
          </Link>
        </li>
      </ul>
    </div>
  );
}
